/**
 * @fileoverview Componente responsável por bloquear a interface com um overlay de carregamento.
 */

import React from "react";

import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { FadeLoader } from "react-spinners";

const useStyles = makeStyles(theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		backgroundColor: "#0d1016 !important",
	},
	loaderWrapper: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	return (
			<Backdrop className={classes.backdrop} open={true}>
				<div className={classes.loaderWrapper}>
					<FadeLoader color="#3a54ae" height={14} margin={-1} radius={2} width={5} />
				</div>
			</Backdrop>
	);
};

export default BackdropLoading;
